
(function () {
	'use strict';

	function toArray(list) {
		return Array.prototype.slice.call(list);
	}

	

	function initDragScroll(scroller) {
		if (scroller.hasAttribute('data-pp-drag-initialized')) return;
		scroller.setAttribute('data-pp-drag-initialized', '');

		var pointerId = null;
		var startX = 0;
		var startScroll = 0;
		var dragged = false;
		var suppressClick = false;

		scroller.addEventListener('dragstart', function (event) {
			event.preventDefault();
		});

		scroller.addEventListener('pointerdown', function (event) {
			if (event.pointerType === 'touch' || event.button !== 0) return;
			if (event.target.closest('button, input, select, textarea')) return;
			if (scroller.scrollWidth <= scroller.clientWidth) return;

			pointerId = event.pointerId;
			startX = event.clientX;
			startScroll = scroller.scrollLeft;
			dragged = false;
		});

		scroller.addEventListener('pointermove', function (event) {
			if (event.pointerId !== pointerId) return;
			var distance = event.clientX - startX;
			if (!dragged && Math.abs(distance) < 5) return;

			if (!dragged) {
				// Pas capturen zodra er echt gesleept wordt, anders vangt de scroller de klik op links af
				scroller.setAttribute('data-pp-dragging', '');
				scroller.setPointerCapture(pointerId);
			}
			dragged = true;
			scroller.scrollLeft = startScroll - distance;
			event.preventDefault();
		});

		function stopDragging(event) {
			if (event.pointerId !== pointerId) return;
			if (scroller.hasPointerCapture(pointerId)) scroller.releasePointerCapture(pointerId);
			scroller.removeAttribute('data-pp-dragging');
			pointerId = null;

			if (dragged && event.type !== 'pointercancel') {
				suppressClick = true;
				window.setTimeout(function () { suppressClick = false; }, 0);
			}
			dragged = false;
		}

		scroller.addEventListener('pointerup', stopDragging);
		scroller.addEventListener('pointercancel', stopDragging);

		
		scroller.addEventListener('click', function (event) {
			if (!suppressClick) return;
			event.preventDefault();
			event.stopPropagation();
		}, true);
	}

	function initCarouselNav(root) {
		if (root.hasAttribute('data-pp-carousel-nav-initialized')) return;

		var scroller = root.querySelector('[data-pp-carousel-track]');
		var previous = root.querySelector('[data-pp-carousel-prev]');
		var next = root.querySelector('[data-pp-carousel-next]');
		if (!scroller || !previous || !next) return;

		root.setAttribute('data-pp-carousel-nav-initialized', '');

		function getStep() {
			var item = scroller.firstElementChild;
			if (!item) return scroller.clientWidth;

			var styles = window.getComputedStyle(scroller);
			var gap = parseFloat(styles.columnGap || styles.gap) || 0;
			return item.getBoundingClientRect().width + gap;
		}

		function update() {
			var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
			var canScroll = maxScroll > 2;
			previous.hidden = !canScroll;
			next.hidden = !canScroll;
			previous.disabled = !canScroll || scroller.scrollLeft <= 2;
			next.disabled = !canScroll || scroller.scrollLeft >= maxScroll - 2;
		}

		function scroll(direction) {
			var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			scroller.scrollBy({
				left: direction * getStep(),
				behavior: reducedMotion ? 'auto' : 'smooth'
			});
		}

		previous.addEventListener('click', function () { scroll(-1); });
		next.addEventListener('click', function () { scroll(1); });
		scroller.addEventListener('scroll', update, { passive: true });
		scroller.addEventListener('pp-carousel-update', update);

		if (typeof ResizeObserver !== 'undefined') {
			new ResizeObserver(update).observe(scroller);
		} else {
			window.addEventListener('resize', update);
		}

		update();
	}

	

	function initAccordion(root) {
		toArray(root.querySelectorAll('[data-pp-accordion-trigger]')).forEach(function (trigger) {
			var panel = document.getElementById(trigger.getAttribute('aria-controls'));
			var item = trigger.closest('.pp-faq__item');
			var hideTimer;
			if (!panel || !item) return;

			panel.addEventListener('transitionend', function (event) {
				if (event.propertyName !== 'grid-template-rows') return;
				if (trigger.getAttribute('aria-expanded') === 'false') panel.hidden = true;
			});

			trigger.addEventListener('click', function () {
				var willOpen = trigger.getAttribute('aria-expanded') !== 'true';
				clearTimeout(hideTimer);
				trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
				panel.setAttribute('aria-hidden', willOpen ? 'false' : 'true');

				if (willOpen) {
					panel.hidden = false;
					
					panel.getBoundingClientRect();
					item.classList.add('is-open');
				} else {
					item.classList.remove('is-open');
					
					hideTimer = setTimeout(function () {
						if (trigger.getAttribute('aria-expanded') === 'false') panel.hidden = true;
					}, 300);
				}
			});
		});
	}

	

	function initClamp(toggle) {
		var target = document.getElementById(toggle.getAttribute('aria-controls'));
		var label = toggle.querySelector('[data-pp-clamp-label]');
		var animation = null;
		if (!target) return;

		
		if (target.scrollHeight <= target.clientHeight + 1) {
			toggle.hidden = true;
			target.classList.remove('is-clamped');
			return;
		}

		function setLabel(expanded) {
			if (label) {
				label.textContent = toggle.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
			}
		}

		
		function getCollapsedHeight() {
			var wasClamped = target.classList.contains('is-clamped');
			target.classList.add('is-clamped');
			var height = target.getBoundingClientRect().height;
			if (!wasClamped) target.classList.remove('is-clamped');
			return height;
		}

		toggle.addEventListener('click', function () {
			var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
			var startHeight = target.getBoundingClientRect().height;
			var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

			
			if (animation) {
				animation.cancel();
				animation = null;
			}

			toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
			setLabel(willOpen);

			if (reducedMotion || typeof target.animate !== 'function') {
				target.classList.toggle('is-clamped', !willOpen);
				return;
			}

			var endHeight;
			if (willOpen) {
				target.classList.remove('is-clamped');
				endHeight = target.getBoundingClientRect().height;
			} else {
				endHeight = getCollapsedHeight();
			}

			target.classList.add('is-animating');
			animation = target.animate(
				[
					{ height: startHeight + 'px' },
					{ height: endHeight + 'px' }
				],
				{
					duration: 260,
					easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
				}
			);

			animation.addEventListener('finish', function () {
				target.classList.toggle('is-clamped', !willOpen);
				target.classList.remove('is-animating');
				animation = null;
			}, { once: true });

			animation.addEventListener('cancel', function () {
				target.classList.remove('is-animating');
			}, { once: true });
		});
	}

	

	function initSpecsToggle(toggle) {
		var section = toggle.closest('.pp-section');
		var body = section ? section.querySelector('[data-pp-specs]') : null;
		if (!body || !body.hasAttribute('data-pp-specs-collapsed')) return;

		toggle.addEventListener('click', function (event) {
			event.preventDefault();
			body.removeAttribute('data-pp-specs-collapsed');
			
			toggle.removeAttribute('data-pp-specs-toggle');
		});
	}

	

	
	function formatMoney(cents, format) {
		var value = (cents / 100).toFixed(2);

		function group(number, thousands, decimal, decimals) {
			var parts = decimals === 0 ? [Math.round(cents / 100).toString(), ''] : number.split('.');
			var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
			return decimals === 0 ? whole : whole + decimal + parts[1];
		}

		return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
			switch (name) {
				case 'amount':
					return group(value, ',', '.', 2);
				case 'amount_no_decimals':
					return group(value, ',', '.', 0);
				case 'amount_with_comma_separator':
					return group(value, '.', ',', 2);
				case 'amount_no_decimals_with_comma_separator':
					return group(value, '.', ',', 0);
				case 'amount_with_apostrophe_separator':
					return group(value, "'", '.', 2);
				case 'amount_with_period_and_space_separator':
					return group(value, ' ', '.', 2);
				case 'amount_no_decimals_with_space_separator':
					return group(value, ' ', '.', 0);
				case 'amount_with_space_separator':
					return group(value, ' ', ',', 2);
				default:
					return match;
			}
		});
	}

	function initBundle(root) {
		var inputs = toArray(root.querySelectorAll('input[name="c4a"]'));
		var totalEl = root.querySelector('[data-pp-bundle-total]');
		var compareEl = root.querySelector('[data-pp-bundle-compare]');
		var format = root.getAttribute('data-money-format') || '{{ amount_with_comma_separator }}';
		var basePrice = parseInt(root.getAttribute('data-base-price'), 10) || 0;
		var baseCompare = parseInt(root.getAttribute('data-base-compare'), 10) || 0;

		function update() {
			var total = basePrice;
			
			var compare = baseCompare > basePrice ? baseCompare : basePrice;
			var hasDiscount = baseCompare > basePrice;

			inputs.forEach(function (input) {
				if (!input.checked || input.disabled) return;
				var price = parseInt(input.getAttribute('data-price'), 10) || 0;
				var itemCompare = parseInt(input.getAttribute('data-compare'), 10) || price;
				total += price;
				compare += itemCompare;
				if (itemCompare > price) hasDiscount = true;
			});

			if (totalEl) totalEl.textContent = formatMoney(total, format);
			if (compareEl) {
				compareEl.textContent = formatMoney(compare, format);
				compareEl.hidden = !hasDiscount;
			}
		}

		inputs.forEach(function (input) {
			input.addEventListener('change', update);
		});

		update();
	}

	

	function initVideo(root) {
		if (root.hasAttribute('data-pp-video-initialized')) return;
		root.setAttribute('data-pp-video-initialized', '');

		var playButton = root.querySelector('[data-pp-video-play]');
		var video = root.querySelector('video');
		var iframe = root.querySelector('iframe');
		if (!playButton || (!video && !iframe)) return;

		playButton.addEventListener('click', function () {
			root.classList.add('is-playing');

			if (video) {
				var playback = video.play();
				if (playback && playback.catch) {
					playback.catch(function () {
						root.classList.remove('is-playing');
					});
				}
				return;
			}

			
			var source = new URL(iframe.src, window.location.href);
			source.searchParams.set('autoplay', '1');
			iframe.src = source.toString();
		});
	}

	

	
	var VIEWED_COOKIE = 'allcam_recently_viewed';
	var VIEWED_MAX = 12;
	var VIEWED_DEFAULT_DAYS = 30;

	function readViewed() {
		if (typeof Cookies === 'undefined') return [];
		var raw = Cookies.get(VIEWED_COOKIE);
		if (!raw) return [];
		return raw.split(',').filter(Boolean);
	}

	function writeViewed(urls, days) {
		if (typeof Cookies === 'undefined') return;
		
		Cookies.set(VIEWED_COOKIE, urls.join(','), {
			expires: days || VIEWED_DEFAULT_DAYS,
			sameSite: 'lax'
		});
	}

	
	function recordViewed() {
		var current = window.general && window.general.viewed_product;
		if (!current) return;

		var section = document.querySelector('[data-pp-viewed]');
		var days = section ? parseInt(section.getAttribute('data-cookie-days'), 10) : 0;

		var list = readViewed().filter(function (url) {
			return url !== current;
		});
		list.push(current);
		if (list.length > VIEWED_MAX) {
			list = list.slice(list.length - VIEWED_MAX);
		}

		writeViewed(list, days);
	}

	function initViewed(root) {
		var list = root.querySelector('[data-pp-viewed-list]');
		if (!list) return;

		var current = window.general && window.general.viewed_product;
		var limit = parseInt(root.getAttribute('data-limit'), 10) || 6;

		
		var items = readViewed()
			.filter(function (url) {
				return url && url !== current;
			})
			.reverse()
			.slice(0, limit);

		
		if (!items.length) return;

		
		Promise.all(
			items.map(function (url) {
				return fetch(url + '?section_id=product-page-card')
					.then(function (response) {
						return response.ok ? response.text() : '';
					})
					.catch(function () {
						return '';
					});
			})
		).then(function (results) {
			var markup = results
				.filter(Boolean)
				.map(function (text) {
					var parsed = new DOMParser().parseFromString(text, 'text/html');
					var section = parsed.getElementById('shopify-section-product-page-card');
					return section ? '<li>' + section.innerHTML + '</li>' : '';
				})
				.filter(Boolean)
				.join('');

			if (!markup) return;
			list.innerHTML = markup;
			root.hidden = false;
			list.dispatchEvent(new Event('pp-carousel-update'));
			if (typeof ajaxCart !== 'undefined' && ajaxCart && typeof ajaxCart.init === 'function') {
				ajaxCart.init();
			}
		});
	}

	

	function initReviewsModal(modal) {
		if (modal.hasAttribute('data-pp-reviews-initialized')) return;
		modal.setAttribute('data-pp-reviews-initialized', '');

		var section = modal.closest('.pp-section') || document;
		var openers = toArray(section.querySelectorAll('[data-pp-reviews-open]'));
		var closeButton = modal.querySelector('[data-pp-reviews-close]');
		var lastOpener = null;

		function open(event) {
			if (typeof modal.showModal !== 'function') return;
			event.preventDefault();
			lastOpener = event.currentTarget;
			modal.showModal();
			document.documentElement.classList.add('pp-reviews-modal-open');
		}

		openers.forEach(function (opener) {
			opener.addEventListener('click', open);
		});

		if (closeButton) {
			closeButton.addEventListener('click', function () {
				modal.close();
			});
		}

		modal.addEventListener('click', function (event) {
			if (event.target === modal) modal.close();
		});

		modal.addEventListener('close', function () {
			document.documentElement.classList.remove('pp-reviews-modal-open');
			if (lastOpener) lastOpener.focus();
		});
	}

	function init() {
		toArray(document.querySelectorAll('[data-pp-accordion]')).forEach(initAccordion);
		toArray(document.querySelectorAll('[data-pp-clamp-toggle]')).forEach(initClamp);
		toArray(document.querySelectorAll('[data-pp-specs-toggle]')).forEach(initSpecsToggle);
		toArray(document.querySelectorAll('[data-pp-bundle]')).forEach(initBundle);
		toArray(document.querySelectorAll('[data-pp-video]')).forEach(initVideo);
		toArray(document.querySelectorAll('.pp-carousel')).forEach(initDragScroll);
		toArray(document.querySelectorAll('[data-pp-carousel-nav]')).forEach(initCarouselNav);

		
		toArray(document.querySelectorAll('[data-pp-viewed]')).forEach(initViewed);
		toArray(document.querySelectorAll('[data-pp-reviews-modal]')).forEach(initReviewsModal);
		recordViewed();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	
	document.addEventListener('shopify:section:load', function (event) {
		var target = event.target;
		toArray(target.querySelectorAll('[data-pp-accordion]')).forEach(initAccordion);
		toArray(target.querySelectorAll('[data-pp-clamp-toggle]')).forEach(initClamp);
		toArray(target.querySelectorAll('[data-pp-specs-toggle]')).forEach(initSpecsToggle);
		toArray(target.querySelectorAll('[data-pp-bundle]')).forEach(initBundle);
		toArray(target.querySelectorAll('[data-pp-video]')).forEach(initVideo);
		toArray(target.querySelectorAll('.pp-carousel')).forEach(initDragScroll);
		toArray(target.querySelectorAll('[data-pp-carousel-nav]')).forEach(initCarouselNav);
		toArray(target.querySelectorAll('[data-pp-viewed]')).forEach(initViewed);
		toArray(target.querySelectorAll('[data-pp-reviews-modal]')).forEach(initReviewsModal);
	});
})();
